import {get} from '@vueuse/core';
import {computed, type MaybeRef} from 'vue';
import {useLink, type RouterLinkProps} from 'vue-router';

/**
 * Composable to easily create required props for PrimeVue buttons which should be displayed as links
 */
export default function useButtonLink(to: MaybeRef<RouterLinkProps['to'] | null>) {
    const route = computed(() => {
        const toValue = get(to);
        if (!toValue) {
            return null;
        }
        const {href, navigate} = useLink({
            to: toValue,
        });

        return {href: href.value, navigate};
    });

    function onClick(event: Event) {
        if (route.value?.navigate) {
            route.value.navigate();
            event.preventDefault();
        }
    }

    const as = computed(() => (route.value ? 'a' : undefined));

    return {route, onClick, as};
}
